import Button from "../util/Button.jsx";
import PowerIcon from "mdi-react/PowerIcon.js";
import {useDispatch, useSelector} from "react-redux";
import {getHasDogAccess, getIsOddy, logout} from "../../ducks/user-duck.js";
import {closePopup} from "../../ducks/popup-duck.js";
import './LinkList.scss'
import BankOutlineIcon from "mdi-react/BankOutlineIcon.js";
import WalletOutlineIcon from "mdi-react/WalletOutlineIcon.js";
import PawIcon from "mdi-react/PawIcon.js";
import InternalLink from "../util/navigation/InternalLink.jsx";
import {APP_ROUTES} from "../../App.jsx";
import {
    FILTER_KEY_ALL,
    FILTER_KEY_LIQUID,
    FILTER_KEY_MANAGED,
    FILTER_KEY_PAPER,
    FILTER_KEY_REAL_ESTATE,
    FILTER_KEY_STOCKS_UNLISTED,
    FILTER_PRESET_NAMES,
} from "../../ducks/assets-duck.js";
import AssetIcon from "../util/icons/AssetIcon.jsx";
import {scrollToDashBoard, useNavigation} from "../util/navigation/navigation.js";
import LightningBoltOutlineIcon from "mdi-react/LightningBoltOutlineIcon.js";
import {PRESETS} from "../live-list/LiveList.jsx";
import Preset from "../live-list/Preset.jsx";
import {useAnnotationLink} from "../annotation/useAnnotationLink.js";
import MessageAlertOutlineIcon from "mdi-react/MessageAlertOutlineIcon.js";
import ChartPieOutlineIcon from "mdi-react/ChartPieOutlineIcon.js";
import CompareIcon from "mdi-react/CompareIcon.js";

const EXTRA_FILTERS = [
    FILTER_KEY_LIQUID,
    FILTER_KEY_PAPER,
    FILTER_KEY_MANAGED,
    FILTER_KEY_STOCKS_UNLISTED,
    FILTER_KEY_REAL_ESTATE,
]

export default () => {

    const dispatch = useDispatch()
    const isOddy = useSelector(getIsOddy)
    const hasDogAccess = useSelector(getHasDogAccess)
    const {annotationRoute} = useAnnotationLink()
    const {getRoute/*, path*/} = useNavigation()

    const onClickClosePopup = () => dispatch(closePopup())

    const onClickLogout = () => {
        dispatch(logout())
        onClickClosePopup()
    }

    return (
        <div className='link-list'>
            <h2>
                App navigation
            </h2>
            <div className='link-list-columns'>
                <div className='column'>
                    <h3>
                        Features
                    </h3>
                    <ul>
                        <li>
                            <InternalLink
                                to={getRoute(APP_ROUTES.filter, {filterId: FILTER_KEY_ALL,})}
                                icon={<AssetIcon filterPreset={FILTER_KEY_ALL}/>}
                                onClick={onClickClosePopup}
                            >
                                All assets list
                            </InternalLink>
                        </li>
                        {isOddy &&
                        <li>
                            <InternalLink
                                to={annotationRoute}
                                icon={<MessageAlertOutlineIcon />}
                                onClick={onClickClosePopup}
                            >
                                Manage annotations
                            </InternalLink>
                        </li>
                        }
                        {isOddy &&
                        <li>
                            <InternalLink
                                to={APP_ROUTES.cryptoBalances}
                                icon={<WalletOutlineIcon />}
                                onClick={onClickClosePopup}
                            >
                                Ethereum accounts
                            </InternalLink>
                        </li>
                        }
                        {isOddy &&
                        <li>
                            <InternalLink
                                to={APP_ROUTES.distro}
                                icon={<ChartPieOutlineIcon />}
                                onClick={onClickClosePopup}
                            >
                                Portfolio distribution
                            </InternalLink>
                        </li>
                        }
                        <li>
                            <InternalLink
                                to={APP_ROUTES.taxReport}
                                icon={<BankOutlineIcon />}
                                onClick={onClickClosePopup}
                            >
                                Tax report
                            </InternalLink>
                        </li>
                        {(hasDogAccess || isOddy) &&
                        <li>
                            <InternalLink
                                to={APP_ROUTES.dawg}
                                icon={<PawIcon />}
                                onClick={onClickClosePopup}
                            >
                                Sushi Dog's Sushi Log
                            </InternalLink>
                        </li>
                        }
                        {isOddy &&
                        <li>
                            <InternalLink
                                to={APP_ROUTES.comparator}
                                icon={<CompareIcon />}
                                onClick={onClickClosePopup}
                            >
                                Comparator
                            </InternalLink>
                        </li>
                        }
                        <li>
                            <InternalLink
                                to={APP_ROUTES.liveList}
                                icon={<LightningBoltOutlineIcon />}
                                onClick={onClickClosePopup}
                            >
                                <div className={'flex-vertical-center'}>
                                    <div>
                                        Live list
                                    </div>
                                    <div className='live-list-presets flex-vertical-center'>
                                        {[...PRESETS].slice(1).map((preset, id) =>
                                            <Preset
                                                key={id}
                                                id={id+1}
                                                presetId={0}
                                                {...preset}
                                            />
                                        )}
                                    </div>
                                </div>
                            </InternalLink>
                        </li>
                    </ul>
                </div>
                <div className='column'>
                    <h3>
                        More filters
                    </h3>
                    <ul>
                        {EXTRA_FILTERS.map(key => (
                            <li key={key}>
                                <InternalLink
                                    to={getRoute(APP_ROUTES.filter, {filterId: key,})}
                                    icon={<AssetIcon filterPreset={key}/>}
                                    onClick={onClickClosePopup}
                                    scrollFn={scrollToDashBoard}
                                >
                                    {FILTER_PRESET_NAMES[key]}
                                </InternalLink>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className='flex-vertical-center footer'>
                <Button
                    onClick={onClickLogout}
                    icon={<PowerIcon/>}
                >
                    Log out
                </Button>
            </div>
        </div>
    )
}